import http from './http';
import {SYSTEM_BASE} from './paths';
import {withPerm} from './perm';

const BASE_URL = `${SYSTEM_BASE}/events`;

export const getEvents = withPerm(async () => {
  const res = await http.get(BASE_URL);
  return res.data;
}, 'GET', `${BASE_URL}`);

export const getEventById = withPerm(async (eventId) => {
  const res = await http.get(`${BASE_URL}/${eventId}`);
  return res.data;
}, 'GET', `${BASE_URL}/{eventId}`);

export const updateEvent = withPerm(async (eventId, payload) => {
  const res = await http.put(`${BASE_URL}/${eventId}`, payload, { headers: { 'Content-Type': 'application/json' } });
  return res.data;
}, 'PUT', `${BASE_URL}/{eventId}`);

export const getListenersByEvent = withPerm(async (eventKey) => {
  const res = await http.get(`${BASE_URL}/${encodeURIComponent(eventKey)}/listeners`);
  return res.data;
}, 'GET', `${BASE_URL}/{eventKey}/listeners`);

// 신규: 이벤트ID 기준 DB 리스너 목록 조회
export const getDbListenersByEventId = withPerm(async (eventId) => {
  const res = await http.get(`${BASE_URL}/${eventId}/listeners/db`);
  return res.data;
}, 'GET', `${BASE_URL}/{eventId}/listeners/db`);

// 신규: 리스너 사용여부 업데이트
export const updateListenerUse = withPerm(async (listenerId, useYn) => {
  const res = await http.put(`${BASE_URL}/listeners/${listenerId}`, { useYn }, { headers: { 'Content-Type': 'application/json' } });
  return res.data;
}, 'PUT', `${BASE_URL}/listeners/{listenerId}`);

// 신규: 리스너 속성 업데이트(useYn, dsctn 중 일부)
export const updateListener = withPerm(async (listenerId, payload = {}) => {
  const res = await http.put(`${BASE_URL}/listeners/${listenerId}`, payload, { headers: { 'Content-Type': 'application/json' } });
  return res.data;
}, 'PUT', `${BASE_URL}/listeners/{listenerId}`);

// 신규: 이벤트 생성
export const createEvent = withPerm(async (payload) => {
  const res = await http.post(`${BASE_URL}`, payload, { headers: { 'Content-Type': 'application/json' } });
  return res.data;
}, 'POST', `${BASE_URL}`);

// 신규: DB 리스너 생성
export const createDbListener = withPerm(async (payload) => {
  const res = await http.post(`${BASE_URL}/listeners`, payload, { headers: { 'Content-Type': 'application/json' } });
  return res.data;
}, 'POST', `${BASE_URL}/listeners`);

// 신규: 이벤트 삭제(단건)
export const deleteEvent = withPerm(async (eventId) => {
  const res = await http.delete(`${BASE_URL}/${eventId}`);
  return res.data;
}, 'DELETE', `${BASE_URL}/{eventId}`);

// 신규: 이벤트 일괄 삭제
export const deleteEventBatch = withPerm(async (ids = []) => {
  const res = await http.delete(`${BASE_URL}`, { data: ids });
  return res.data;
}, 'DELETE', `${BASE_URL}`);

// 신규: 선택갱신(일괄)
export const applyEventUpdate = withPerm(async (ids = []) => {
  const res = await http.post(`${BASE_URL}/apply`, { eventIds: ids }, { headers: { 'Content-Type': 'application/json' } });
  return res.data;
}, 'POST', `${BASE_URL}/apply`);

// 신규: DB 리스너 전체 목록 조회 (전역)
export const getAllDbListeners = withPerm(async () => {
  const res = await http.get(`${BASE_URL}/listeners`);
  return res.data;
}, 'GET', `${BASE_URL}/listeners`);

// 신규: 리스너 메타 전체 목록(통합)
export const getUnifiedListeners = withPerm(async () => {
  const res = await http.get(`${BASE_URL}/listeners/unified`);
  return res.data;
}, 'GET', `${BASE_URL}/listeners/unified`);
